import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const IncentiveProgress = gql`
  query IncentiveProgress($input: IncentiveProgressInput!) {
    incentiveProgress(input: $input) {
      __typename
      ... on IncentiveProgressSuccess {
        progress {
          id
          cumulativeValue
          effectiveAt
        }
      }
      ... on IncentiveProgressError {
        ...error
      }
    }
  }
  ${error}
`;

export default IncentiveProgress;
